import MaterialLink, { LinkProps as MaterialLinkProps } from '@mui/material/Link'
import { Link as FoundLink, LinkPropsNodeChild } from 'found'
import React from 'react'

function CustomLink(props: MaterialLinkProps) {
  return <MaterialLink variant="button" underline="hover" {...props} />
}

export default function LinkButton(props: LinkPropsNodeChild) {
  return <FoundLink as={CustomLink} {...props} />
}
